import { createAction, props } from '@ngrx/store';
import { ResizeViewState } from '../reducers';

export const resizeview = createAction(
    '[Cambio de tamaño la vista] resizeview',
    props<ResizeViewState>()
);
export const updateOrientation = createAction('[Resize View] Update Orientation');
